import React, { PureComponent } from 'react'
import { ReactComponent as Icon } from './assets/weavescope.svg'
import SvgIcon from '@material-ui/core/SvgIcon'

export default class Weavescope extends PureComponent {
  render() {
    return <SvgIcon component={Icon} viewBox='0 0 400 400' />
  }
}
